import { personLabel } from "./people.js";

const round2 = (value) => Math.round((Number(value) || 0) * 100) / 100;

export function isBudgetedCategory(category, budgetComparison = []) {
  const transactionCategory = (category || "").toLowerCase();
  if (!transactionCategory) return false;

  return budgetComparison.some((budget) => {
    if (budget.is_unbudgeted) return false;
    const budgetCategory = (budget.category || "").toLowerCase();
    if (!budgetCategory) return false;
    return (
      budgetCategory === transactionCategory ||
      budgetCategory.includes(transactionCategory) ||
      transactionCategory.includes(budgetCategory)
    );
  });
}

/**
 * Spending by person for the current transaction set.
 * Budgeted means the category matches a monthly budget line.
 * Discretionary means the charge is outside those budget lines.
 */
export function buildPersonSpending(transactions = [], budgetComparison = []) {
  const totals = new Map();

  for (const transaction of transactions) {
    const name = personLabel(transaction.responsible_person);
    if (!totals.has(name)) {
      totals.set(name, {
        name,
        value: 0,
        budgeted: 0,
        discretionary: 0,
        count: 0,
      });
    }

    const row = totals.get(name);
    const amount = Number(transaction.amount) || 0;
    row.value += amount;
    row.count += 1;

    if (isBudgetedCategory(transaction.final_category, budgetComparison)) {
      row.budgeted += amount;
    } else {
      row.discretionary += amount;
    }
  }

  const people = [...totals.values()]
    .map((row) => ({
      ...row,
      value: round2(row.value),
      budgeted: round2(row.budgeted),
      discretionary: round2(row.discretionary),
    }))
    .sort((a, b) => b.value - a.value);

  const totalSpent = round2(people.reduce((sum, row) => sum + row.value, 0));
  const totalDiscretionary = round2(
    people.reduce((sum, row) => sum + row.discretionary, 0),
  );
  const budgetTotal = round2(
    budgetComparison
      .filter((item) => !item.is_unbudgeted)
      .reduce((sum, item) => sum + (Number(item.budgeted) || 0), 0),
  );

  return {
    people: people.map((row) => ({
      ...row,
      percentOfSpending:
        totalSpent > 0 ? round2((row.value / totalSpent) * 100) : 0,
      percentOfBudget:
        budgetTotal > 0 ? round2((row.value / budgetTotal) * 100) : 0,
      percentOfDiscretionary:
        totalDiscretionary > 0
          ? round2((row.discretionary / totalDiscretionary) * 100)
          : 0,
    })),
    totalSpent,
    totalDiscretionary,
    budgetTotal,
  };
}
